import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import BreadcrumbsBg from "../Assets/img/breadcrumbs-bg.png";
import axios from "axios";
import RecentPostImg1 from "../Assets/img/blog/sm-img-1.jpg";
import RecentPostImg2 from "../Assets/img/blog/sm-img-2.jpg";
import RecentPostImg3 from "../Assets/img/blog/sm-img-3.jpg";

const Blog = () => {
  const [blogSection, setBlogSection] = useState([]);
  const [allBlogs, setAllBlogs] = useState([]);
  useEffect(() => {
    axios.get("JSON/news&events.json").then((response) => {
      setBlogSection(response.data[0]);
      setAllBlogs(response.data[0].blogs.reverse());
    });
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section
        className="eschool-breadcrumbs"
        style={{ backgroundImage: `url(${BreadcrumbsBg})` }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-12">
              <div className="eschool-breadcrumbs-content">
                <h3 className="eschool-bread-cont-title">Blog/Events</h3>
                <ul className="eschool-bread-menu">
                  <li>
                    <Link to="/">Home</Link>
                    <i class="fi fi-br-angle-right"></i>
                  </li>
                  <li className="active">
                    <Link to="/blog">Blogs/Events</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="blog-page-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-xl-8 col-12">
              <div className="blog-card-right">
                {allBlogs?.slice(1, 6)?.map((singleBlog) => (
                  <div className="blog-card card-small">
                    <div className="blog-card-img blog-card-sm-img">
                      <img src={singleBlog?.img} alt="#" />
                      <span className="blog-card-category">
                        {singleBlog.category}
                      </span>
                    </div>
                    <div className="blog-card-content card-sm-content">
                      <ul className="blog-meta-list">
                        <li>
                          <Link to="#">
                            <i className="fi fi-rr-alarm-clock"></i>
                            {singleBlog?.date}
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            <i className="fi fi-rr-user"></i>by{" "}
                            {singleBlog?.writer}
                          </Link>
                        </li>
                      </ul>
                      <h4 className="blog-card-title blog-page-card-title">
                        <Link to="/blogsingle">{singleBlog?.title}</Link>
                      </h4>
                      <Link to="/blogsingle" className="eschool-btn">
                        Read more<i className="fi fi-rs-arrow-right"></i>
                      </Link>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="col-lg-12 col-xl-4 col-12">
              <div className="blog-sidebar-area">
                <div className="blog-sidebar-widget seacrh-bar">
                  <form action="#" method="post">
                    <input type="text" placeholder="Search" required />
                    <button type="submit" className="seacrh-bar-btn">
                      <i className="fi fi-rr-search"></i>
                    </button>
                  </form>
                </div>
                <div className="blog-sidebar-widget sidebar-topic">
                  <h4 className="b-sidebar-widget-title">Topics</h4>
                  <ul className="sidebar-topic-list">
                    <li>
                      <Link to="#">
                        {" "}
                        Blogs<span>20</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        {" "}
                        Events<span>10</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        {" "}
                        Education<span>14</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        {" "}
                        Cultural<span>8</span>
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="blog-sidebar-widget recents-post">
                  <h4 className="b-sidebar-widget-title">Recent posts</h4>
                  <div className="blog-sid-recent-post-inner">
                    <div className="blog-sid-recent-post-single">
                      <div className="blog-sid-recent-img">
                        <img src={RecentPostImg1} alt="#" />
                      </div>
                      <div className="blog-sid-recent-content">
                        <ul className="blog-sid-recent-cont-list">
                          <li>
                            <Link to="#">
                              <i class="fi fi-rr-calendar"></i>
                              November 03,2022
                            </Link>
                          </li>
                          <li>
                            <Link to="#">
                              <i class="fi fi-rs-calendar-clock"></i>
                              Events
                            </Link>
                          </li>
                        </ul>
                        <h6 className="blog-sid-recent-cont-title">
                          Toanmisra mission critical action life items rather
                          Gotan
                        </h6>
                        <Link to="#" className="blog-sid-recent-cont-btn">
                          Read More<i className="fi fi-rs-arrow-right"></i>
                        </Link>
                      </div>
                    </div>
                    <div className="blog-sid-recent-post-single">
                      <div className="blog-sid-recent-img">
                        <img src={RecentPostImg2} alt="#" />
                      </div>
                      <div className="blog-sid-recent-content">
                        <ul className="blog-sid-recent-cont-list">
                          <li>
                            <Link to="#">
                              <i class="fi fi-rr-calendar"></i>
                              November 03,2022
                            </Link>
                          </li>
                          <li>
                            <Link to="#">
                              <i class="fi fi-rs-calendar-clock"></i>
                              Blog
                            </Link>
                          </li>
                        </ul>
                        <h6 className="blog-sid-recent-cont-title">
                          Repurpose mission critical action life items rather
                          total linkagesuds
                        </h6>
                        <Link to="#" className="blog-sid-recent-cont-btn">
                          Read More<i className="fi fi-rs-arrow-right"></i>
                        </Link>
                      </div>
                    </div>
                    <div className="blog-sid-recent-post-single">
                      <div className="blog-sid-recent-img">
                        <img src={RecentPostImg3} alt="#" />
                      </div>
                      <div className="blog-sid-recent-content">
                        <ul className="blog-sid-recent-cont-list">
                          <li>
                            <Link to="#">
                              <i class="fi fi-rr-calendar"></i>
                              November 03,2022
                            </Link>
                          </li>
                          <li>
                            <Link to="#">
                              <i class="fi fi-rs-calendar-clock"></i>
                              Events
                            </Link>
                          </li>
                        </ul>
                        <h6 className="blog-sid-recent-cont-title">
                          Toanmisra mission critical action life items rather
                          Gotan
                        </h6>
                        <Link to="#" className="blog-sid-recent-cont-btn">
                          Read More<i className="fi fi-rs-arrow-right"></i>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 col-xl-8 col-12">
              <div className="blog-bottom-btn">
                <Link to="#" className="eschool-btn secondary-btn">
                  Load More<i className="fi fi-rs-arrow-right"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Blog;
